import script from "./UnlockFreeAccessModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./UnlockFreeAccessModal.vue?vue&type=script&setup=true&lang=ts"

import "./UnlockFreeAccessModal.vue?vue&type=style&index=0&id=28719e21&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28719e21"]])

export default __exports__